import { Button } from "components/common";
import useBottomSheet from "hooks/common/useBottomSheet";

const ParagraphItem = ({ title, description }: { title: string; description: string }) => {
  return (
    <div className="flex w-full flex-col justify-center gap-1 rounded-lg bg-base-bg-subtle px-4 py-3 text-left">
      <div className="typography-headline-md text-base-txt-primary">{title}</div>
      <div className="typography-body-sm text-base-txt-secondary" dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );
};

const NewAppNotice = () => {
  const { close, sheets } = useBottomSheet();
  const sheet = sheets.NewAppNotice;

  return (
    <>
      <div className="sticky left-0 right-0 top-0 z-10 flex flex-col items-center justify-center gap-2 bg-dialog-bg-default">
        <div className="typography-title-xl text-dialog-txt-default">NEW LINKLE</div>
        <img src="/imgweb/icons/ic_linkle.png" alt="" style={{ width: '35dvw', height: '35dvw' }} />
      </div>
      <div className="relative flex h-full w-full flex-col items-center gap-4 overflow-auto text-center">
        <div className="flex min-h-0 flex-1 flex-col gap-2">
          <div className="typography-headline-lg">{brsc.renewal_title}</div>
          <div className="typography-body-sm" dangerouslySetInnerHTML={{ __html: brsc.renewal_body }} />
          <div style={{ height: '0.6rem' }} />
          <ParagraphItem title={brsc.freecoin_title} description={brsc.freecoin_body} />
          <ParagraphItem title={brsc.price_title} description={brsc.price_body} />
          <ParagraphItem title={brsc.bothend_title} description={brsc.bothend_body} />
        </div>
      </div>
      <div
        className="sticky bottom-0 left-0 right-0 z-10 mt-4 flex w-full flex-row gap-3 bg-dialog-bg-default px-4 py-4"
        style={{ transform: 'translateY(calc(var(--navigation-bar-height) + 16px))' }}
      >
        <Button
          onClick={() => close(sheet.id)}
          style={{ text: brsc.all_check_1, color: 'btn-bg-primary', fontColor: 'btn-txt-primary', borderRadius: 'full' }}
          className="w-full"
        />
      </div>
    </>
  );
};

export default NewAppNotice;